<template>
<div>

    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">
                    <div class="card-header">
                        <i class="fas fa-user-shield"></i><span> Roles</span>
                        <div class="btn-group" role="group">
                            <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i>Agregar</button>
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->

                            <div class="form-group row">

                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getListarRol(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>

                                <div class="col-md-6 col-sm-12">
                                    <div>
                                        <el-input @keyup.enter.native="getListarRol(1,pag_mostrar)" placeholder="Texto a buscar" v-model="cBusqueda" class="input-with-select" clearable>
                                            <el-select v-model="cCriterio" slot="prepend" placeholder="Select">
                                            <el-option value="name" label="Nombre"></el-option>
                                            <el-option value="slug" label="Url"></el-option>
                                            </el-select> <i class="fas fa-search"></i>
                                            <el-button class="button-library-group" slot="append" icon="fas fa-search" @click.prevent="getListarRol(1,pag_mostrar)"></el-button>
                                        </el-input>
                                    </div>
                                </div>

                            </div>

                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Nombre</b></th>
                                            <th><b>Url Amigable</b></th>
                                            <th><b>Acciones</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listRol.length">
                                        <tr v-for="(r, index) in listRol" :key="index">

                                            <td v-text="r.name"></td>
                                            <td v-text="r.slug"></td>

                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                        <button class="dropdown-item"  @click="setVerRol(r.id)"><i class="far fa-eye" ></i> Ver</button>
                                                        <button class="dropdown-item"  @click="setObtenerRol(r.id)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        <button class="dropdown-item" @click="setObtenerRol(r.id)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>

                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="8" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                 <nav style="float: right;">


                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Roles-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal">Registrar rol con sus permisos</h5>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row row-cols-sm-1 row-cols-md-1 row-cols-lg-1">
                            <div class="col-md-12 col-lg-5 col-sm-12">
                                <div class="card">
                                    <div class="card-header bg-info color-text-p" v-text="tituloCard"></div>
                                    <div class="card-body">
                                        <form :class="[ver_rol_permiso == true ? 'bloquear' : '']">
                                            <div class="row">

                                                <div class="col-md-12">
                                                    <div class="form-group"><label for="LeadName">Nombre</label>
                                                        <input type="text" class="form-control" id="nombre" v-model="vaCreRol.cNombre"  placeholder="Ingresar nombre del rol">
                                                    </div>
                                                </div>

                                                <div class="col-md-12">
                                                    <div class="form-group"><label for="LeadName">Url amigable</label>
                                                        <input type="text" class="form-control" id="url" v-model="vaCreRol.cSlug"  placeholder="Ingresar url amigable">
                                                    </div>
                                                </div>

                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 col-lg-7 col-sm-12">
                                <div class="card">
                                    <div class="card-header bg-info color-text-p" v-text="titleListarPermisos"> Lista de Permisos</div>
                                    <div class="card-body">
                                        <div class="row">
                                                <div class="col-md-5">

                                                    <div class="input-group" style="padding-bottom: 10px;">
                                                        <span class="input-group-btn">
                                                            <button type="button" class="btn waves-effect waves-light btn-primary"  @click="seleccionarTodoRol()">
                                                                <i :class="(selectDeselectAllRoles == true) ? 'far fa-check-square fa-lg': 'far fa-square fa-lg'"></i>
                                                            </button>
                                                        </span>
                                                        <label for="" class="form-control">Seleccionar todo</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-7">
                                                    <div class="input-group" style="padding-bottom: 10px;">
                                                        <span class="input-group-btn">
                                                            <button type="button"
                                                                class="btn waves-effect waves-light btn-primary">
                                                                <i class="fa fa-search"></i>
                                                            </button>
                                                        </span>
                                                        <input type="text" class="form-control" v-model="buscarNombre_rol"  placeholder="Buscar..." />
                                                        <span class="input-group-btn">
                                                            <button type="button" class="btn waves-effect waves-light btn-primary" @click="buscarNombre_rol=''">
                                                                <i class="far fa-times-circle"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        <div class="scrollTable">
                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th v-if="!ver_rol_permiso">Seleccionar</th>
                                                        <th>Nombre</th>
                                                        <th>Url Amigable</th>

                                                    </tr>
                                                </thead>
                                                <tbody v-if="listPermisosFilter.length">
                                                    <tr v-for="(item, index) in filtrolistaPermisosRoles" :key="index" @click.prevent="marcarFila(index)">
                                                        <td v-if="!ver_rol_permiso">
                                                            <div class="checkbox checkbox-primary d-inline">
                                                                <input @click="selectDeselectAllRoles=false" type="checkbox" name="checkbox-p-1" id="checkbox-p-1" v-model="item.checked">
                                                                <label for="checkbox-p-1" class="cr"></label>
                                                            </div>
                                                        </td>
                                                        <td v-text="item.name">1</td>
                                                        <td v-text="item.slug">1</td>
                                                    </tr>

                                                </tbody>
                                                <tbody v-else>
                                                <tr>
                                                    <td colspan="3" align="center">
                                                        <h5>No se encontraron resultados...</h5>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="modal-footer" v-if="!ver_rol_permiso">
                            <button type="button" v-if="actu_reg==0" class="btn btn-sm btn-primary"  @click="setRegistrarRolPermiso" v-text="nameButon">Guardar</button>
                            <button type="button" v-if="actu_reg==1" class="btn btn-sm btn-primary" @click="setActualizarRol" v-text="nameButon">Actualizar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>
                     <div class="modal-footer" v-if="ver_rol_permiso">
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Roles-------------------------------------------------------------->

    </div>

</div>
</template>

<script>

import {alertasM} from '../../../util.js';
export default {
    props: ['ruta'],
    data() {
        return {
            cCriterio: 'name',
            cBusqueda: '',
            listRol: [],
            listPermisosFilter: [],
            listPermisos: [],
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo dataTable
            modalShow: false,

            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCreRol:{
                eId: 0,
                cNombre: '',
                cSlug: '',
            },
            tituloCard: '',
            tituloModal: '',
            nameButon: '',
            titleListarPermisos: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            ver_rol_permiso: false,
            listRolPermisosByUsuario: [],
            listRolPermisosByUsuarioFilter: [],
            selectDeselectAllRoles: false,
            buscarNombre_rol: '',



        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },

            filtrolistaPermisosRoles(){

                return this.listPermisosFilter.filter(rol => {
                    return rol.name.toLowerCase().includes(this.buscarNombre_rol.toLowerCase())
                });
            }
        },
    methods: {

        getListarRol(page,pag_mostrar){

          var url = '/administracion/rol/getListar';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'cCriterio': this.cCriterio,
                  'cBusqueda': this.cBusqueda,
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {
                var respuesta = res.data;
                this.listRol = respuesta.rol.data;
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
              console.error(err);
              this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })

        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getListarRol(page,me.pag_mostrar);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;

            if(this.modalShow==true){

                this.tituloCard = "Registrar Rol";
                this.tituloModal = "Registrar rol con sus permisos"
                this.titleListarPermisos = "Lista de Permisos"
                this.actu_reg = 0;
                this.nameButon = "Guardar";
                this.ver_rol_permiso = false

                this.getListarPermisosByRol();


            }else{
                this.aTipoDocumento = [];
                this.cleanVariables();
            }
        },

        cleanVariables(){
            this.vaCreRol.cSlug = "";
            this.vaCreRol.cNombre  = "";
            this.vaCreRol.eId = "";
            this.listPermisos = [];
            this.listPermisosFilter = [];
            this.ver_rol_permiso = false;
            //$("#for-rol")[0].reset();
        },

        setRegistrarRolPermiso(){

            if (this.validarRegistrarRolPermisos()) {
                    //this.modalShow = true;
                    return;
                }
            //console.log("xd");

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/administracion/rol/registrar';

            axios.post(url, {
                    'Nombre'                : this.vaCreRol.cNombre,
                    'cSlug'                  : this.vaCreRol.cSlug,
                    'listPermisosFilter'    : this.listPermisosFilter,
            }).then(res => {

                this.cleanVariables();//Limpiamos el form
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.getListarRol(1,this.pag_mostrar);
                //this.modalShow=false;
                if(res.data.status){

                    this.notify(" Rol registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    this.modalShow=false;
                }else{

                    this.notify(" Error al registrar Rol","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
                console.error(err);
            })
        },

        setActualizarRol(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/administracion/rol/actualizar';

            axios.post(url, {
                    'id'                    : this.vaCreRol.eId,
                    'Nombre'                : this.vaCreRol.cNombre,
                    'cSlug'                 : this.vaCreRol.cSlug,
                    'listPermisosFilter'    : this.listPermisosFilter,
            }).then(res => {


                this.cleanVariables();//Limpiamos el form
                this.getListarRolPermisosByUsuario();
                this.getListarRol(1,this.pag_mostrar);

                if(res.data.status){

                    this.notify(" Rol actualizado con éxito","","top","center","fas fa-user-check","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
                console.error(err);
            })
        },

        setObtenerRol(id){

            var url = '/administracion/rol/obtenerrol';
            this.openCargando();//Activamos ventana de carga de bloqueo
            this.tituloCard = "Actualizar Rol";
            this.tituloModal = "Actualizar rol con sus permisos";
            this.titleListarPermisos = "Lista de Permisos";
            this.nameButon = "Actualizar";
            this.actu_reg = 1;
            this.ver_rol_permiso = false;

            axios.get(url,{params:{'id': id}})
            .then(res => {
                let me = this;
                var respuesta = res.data;

                me.vaCreRol.eId                = respuesta.rol[0].id;
                me.vaCreRol.cNombre            = respuesta.rol[0].name;
                me.vaCreRol.cSlug              = respuesta.rol[0].slug;
                me.listPermisos                = respuesta.permiso;



                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.modalShow = true;
                this.filterPermisosByRol();



            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.actu_reg = 0;
                console.error(err);

            })
        },

        getListarPermisosByRol(){
                this.openCargando();//Activamos pantalla de carga de bloqueo
                var ruta = '/administracion/rol/getListarPermisosByRol'
                axios.get(ruta).then( response => {
                    this.listPermisos = response.data;
                    this.filterPermisosByRol();
                    this.openCargando(true);//desactivamos pantalla de carga de bloqueo
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                        this.openCargando(true);//desactivamps pantalla de carga de bloqueo
                    }
                })
        },

        filterPermisosByRol() {
                let me = this;
                if(me.actu_reg==0){
                        me.listPermisos.map(function(x, y){
                        me.listPermisosFilter.push({
                            'id'        :   x.id,
                            'name'      :   x.name,
                            'slug'      :   x.slug,
                            'checked'   :   false
                            })
                         });
                }else if(me.actu_reg==1){
                    me.listPermisos.map(function(x, y){
                    me.listPermisosFilter.push({
                        'id'        :   x.id,
                        'name'      :   x.name,
                        'slug'      :   x.slug,
                        'checked'   :   (x.checked == 1) ? true : false
                    })
                })
                }

        },

        marcarFila(index){
                this.listPermisosFilter[index].checked  =   !this.listPermisosFilter[index].checked;
        },

        validarRegistrarRolPermisos(){


                if (!this.vaCreRol.cNombre) {

                    this.notify(" El Nombre es un campo obligatorio","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    return true;


                }
                if (!this.vaCreRol.cSlug) {

                    this.notify(" La Url Amigable es un campo obligatorio","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                   return true;
                }

                let contador = 0;
                this.listPermisosFilter.map(function(x, y){
                    if (x.checked == true) {
                        contador++;
                    }
                })
                if (contador == 0) {
                    this.notify(" Debe seleccionar al menos un permiso","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                    return true;
                }

            return false;

        },

        setVerRol(id){

            var url = '/administracion/rol/verrol';
            this.openCargando();//Activamos ventana de carga de bloqueo
            this.tituloCard = "Rol";
            this.tituloModal = "Detalle del rol y permisos asignados"
            this.titleListarPermisos = "Lista de Permisos asignados"
            this.nameButon = "Actualizar"
            this.actu_reg = 1;
            this.ver_rol_permiso = true;

            axios.get(url,{params:{'id': id}})
            .then(res => {
                let me = this;
                var respuesta = res.data;

                me.vaCreRol.eId                = respuesta.rol[0].id;
                me.vaCreRol.cNombre            = respuesta.rol[0].name;
                me.vaCreRol.cSlug              = respuesta.rol[0].slug;
                me.listPermisos                = respuesta.permiso;



                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.filterPermisosByRol();
                this.modalShow = true;



            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.actu_reg = 0;
                console.error(err);

            })
        },

        //Listamos permisos del rol y user
        getListarRolPermisosByUsuario(){
                var ruta = '/administracion/usuario/getListarRolPermisosByUsuario'
                axios.get(ruta).then( response => {

                    this.listRolPermisosByUsuario = response.data;//Guardamos la data en un array
                    this.filterListarRolPermisosByUsuario();

                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                })
        },
        //Filtramos y solo guardamos la url amigable
        filterListarRolPermisosByUsuario() {
                let me = this;
                me.listRolPermisosByUsuarioFilter = [];

                me.listRolPermisosByUsuario.map(function(x, y){
                    me.listRolPermisosByUsuarioFilter.push(x.slug)
                })
                localStorage.setItem('listRolPermisosByUsuario', JSON.stringify(me.listRolPermisosByUsuarioFilter));
                EventBus.$emit('notifyRolPermisosByUsuario', me.listRolPermisosByUsuarioFilter);
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                this.modalShow=false;
        },

        seleccionarTodoRol(){
            for (let index = 0; index < this.listPermisosFilter.length; index++) {
                this.listPermisosFilter[index].checked = !this.selectDeselectAllRoles;
            }
            this.selectDeselectAllRoles =!this.selectDeselectAllRoles;
        },


    },
    mounted() {

            this.getListarRol(1,this.pag_mostrar);



        },
}
</script>

<style>
</style>
